import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Section } from "../../Common/layout/Section";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";
import { ReportMenu } from "../../Common/layout/aside/aside-menu-lists/ReportMenu";
import { Redirect } from "react-router-dom";
import { ActivityReportTable } from "./ActivityReportTable";
import { LastTradedReportTable } from "./LastTradedReportTable";
import { HoldingsTypeReportTable } from "./HoldingsTypeReportTable";

const ReportManagementPages = () => {
  return (
    <>
      <AsideMenu>
        <ReportMenu destination="/reports" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <ContentRoute
              path="/reports/activity"
              permission={Permissions.TRANSACTIONS}
              component={ActivityReportTable}
            />
            <ContentRoute
              path="/reports/last-traded"
              permission={Permissions.TRANSACTIONS}
              component={LastTradedReportTable}
            />
            <ContentRoute
              path="/reports/holding-type"
              permission={Permissions.TRANSACTIONS}
              component={HoldingsTypeReportTable}
            />
            <Redirect to="/reports/activity" />
          </Switch>
        </Suspense>
      </Section>
    </>
  );
};

export default ReportManagementPages;
